import React from 'react';
import Icon from 'components/AppIcon';

const TodaysSchedule = () => {
  const todaysEvents = [
    {
      id: 1,
      type: "court",
      title: "High Court Hearing",
      case: "Kamau vs. Njoroge",
      time: "09:00",
      location: "Milimani High Court, Room 12",
      status: "upcoming",
      priority: "high"
    },
    {
      id: 2,
      type: "meeting",
      title: "Client Consultation",
      case: "Wanjiku Estate Planning",
      time: "11:30",
      location: "Office Conference Room",
      status: "upcoming",
      priority: "medium"
    },
    {
      id: 3,
      type: "court",
      title: "Magistrate Court",
      case: "Mwangi Traffic Case",
      time: "14:00",
      location: "Kibera Law Courts",
      status: "completed",
      priority: "low"
    },
    {
      id: 4,
      type: "meeting",
      title: "Contract Review Meeting",
      case: "ABC Ltd Partnership",
      time: "16:00",
      location: "Client Office - Westlands",
      status: "upcoming",
      priority: "high"
    }
  ];

  const getEventIcon = (type) => {
    return type === 'court' ? 'Scale' : 'Users';
  };

  const getStatusColor = (status) => {
    return status === 'completed' ? 'text-success' : 'text-primary';
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'border-l-accent';
      case 'medium': return 'border-l-warning-500';
      default: return 'border-l-secondary-300';
    }
  };

  return (
    <div className="bg-surface rounded-lg shadow-card border border-border">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-heading font-semibold text-text-primary">Today's Schedule</h2>
          <button className="text-primary hover:text-primary-700 transition-smooth">
            <Icon name="Plus" size={20} />
          </button>
        </div>
        <p className="text-sm text-text-secondary mt-1">
          {new Date().toLocaleDateString('en-KE', { 
            weekday: 'long',
            day: '2-digit',
            month: 'long'
          })}
        </p>
      </div>

      <div className="p-6">
        <div className="space-y-4">
          {todaysEvents.map((event) => (
            <div 
              key={event.id} 
              className={`border-l-4 ${getPriorityColor(event.priority)} bg-secondary-50 rounded-r-lg p-4 hover:bg-secondary-100 transition-smooth cursor-pointer`}
            >
              <div className="flex items-start justify-between">
                <div className="flex items-start space-x-3 flex-1">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                    event.type === 'court' ? 'bg-primary-100 text-primary' : 'bg-secondary-200 text-secondary-600'
                  }`}>
                    <Icon name={getEventIcon(event.type)} size={16} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-medium text-text-primary truncate">
                      {event.title}
                    </h3>
                    <p className="text-xs text-text-secondary mt-1">{event.case}</p>
                    <div className="flex items-center space-x-4 mt-2">
                      <div className="flex items-center space-x-1">
                        <Icon name="Clock" size={12} className="text-text-secondary" />
                        <span className="text-xs text-text-secondary">{event.time}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <Icon name="MapPin" size={12} className="text-text-secondary" />
                        <span className="text-xs text-text-secondary truncate">{event.location}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex items-center space-x-2 ml-2">
                  <span className={`w-2 h-2 rounded-full ${getStatusColor(event.status)}`}></span>
                  <Icon name="ChevronRight" size={16} className="text-text-secondary" />
                </div>
              </div>
            </div>
          ))}
        </div>

        <button className="w-full mt-4 py-2 text-sm text-primary hover:text-primary-700 font-medium transition-smooth">
          View Full Calendar
        </button>
      </div>
    </div>
  );
};

export default TodaysSchedule;